const initialState = {
  endPoints: [],
};

const endpointReducer = (state = initialState, action) => {
  switch (action.type) {
    case "END_POINTS":
      return {
        ...state,
        endPoints: action.payload,
      };
    default:
      return state;
  }
};

export default endpointReducer;
